import React, { FunctionComponent } from 'react';

import { Modal } from 'components';
import { Text } from 'components/chroma';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  modalHelpText: string;
}

const HelpTextModal: FunctionComponent<ModalProps> = ({
  isOpen,
  onClose,
  modalHelpText,
}) => (
  <Modal
    header="What is considered as contents?"
    isOpen={isOpen}
    onClose={onClose}
  >
    <Text>{modalHelpText}</Text>
  </Modal>
);

export default HelpTextModal;
